export const COMPETITION_ROUTE_PREFIX = "/competition";

export const COMPETITION_ROUTE_PATHS = {
  china: { path: "china", to: `${COMPETITION_ROUTE_PREFIX}/china` },
  slovenia: { path: "slovenia", to: `${COMPETITION_ROUTE_PREFIX}/slovenia` },
};
